import { render, staticRenderFns } from "./guidePageBtn.vue?vue&type=template&id=1d125018&scoped=true"
import script from "./guidePageBtn.vue?vue&type=script&lang=js"
export * from "./guidePageBtn.vue?vue&type=script&lang=js"
import style0 from "./guidePageBtn.vue?vue&type=style&index=0&id=1d125018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d125018",
  null
  
)

export default component.exports